'use strict';

class ThemeBar {
  constructor($scope, $location, $window) {
    this.$scope = $scope;
    this.$location = $location;
    this.$window = $window;
  }

  $onInit() {
    let storageTheme = this.$window.localStorage.getItem('theme');

    let currentTheme = document.body.classList.contains('dark-mode') ? 'dark' : 'light';
    if (storageTheme === null) {
      this.$window.localStorage.setItem('theme', currentTheme);
      storageTheme = this.$window.localStorage.getItem('theme');
    }
    if (storageTheme !== currentTheme) {
      document.body.classList.toggle('dark-mode');
    }
  }

  switch() {
    let storageTheme = this.$window.localStorage.getItem('theme');
    let currentTheme = document.body.classList.contains('dark-mode') ? 'dark' : 'light';

    document.body.classList.toggle('dark-mode');

    currentTheme = document.body.classList.contains('dark-mode') ? 'dark' : 'light';
    this.$window.localStorage.setItem('theme', currentTheme);
  }
}

ThemeBar.$inject = ['$scope', '$location', '$window'];

const themeBar = {
  controller: ThemeBar,
  template: `
    <span id="themeBar">
      <a href class="button small secondary" style="margin-top: 3px !important;" ng-click="$ctrl.switch()">
        <i class="fa fa-moon-o" aria-hidden="true"></i>
      </a>
    </span>
  `
};

angular
  .module('sr.theme', [])
  .component('themeBar', themeBar);
